import * as React from 'react';
import { Button, Dropdown, Popup, Icon } from 'semantic-grab-ui/src';
import _ from 'lodash';
import { ConditionWidget, ActionWidget, ExperimentWidget } from 'components/form/trident-campaigns';
import { getNodePopupContent, getDefaultNodeName } from 'omega-rtc/utils/trident-node-utils';
import { renderDropdownItem, getNodeTypeChildOptions } from './util';
import { CampaignWidgetProps } from 'types/ts/campaigns';
import { nodeTypes } from 'data/trident-types';
import './FlowDesign.scss';

export default class EnumerationWidget extends React.Component<CampaignWidgetProps> {
  render() {
    const { model, currentNodeKey, parentKeyList } = this.props;
    const buttonStyle = {
      width: 150,
      height: 60,
      borderRadius: 10,
      border: '1px solid #8bc4fd',
      backgroundColor: 'ghostwhite',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    };
    const buttonStyleClicked = {
      ...buttonStyle,
      border: '1px solid #4aadfc',
      backgroundColor: 'lavender',
    };
    const addButtonSize = {
      fontSize: '1.5em',
      marginTop: '20px',
      color: '#3498DB',
    };

    // preparing ancestor list of current clicked node to send it into node preview display.
    const renderAddButton = _.get(model.nodes[currentNodeKey], 'children', []).length === 0;
    const ancestorList = _.concat(parentKeyList, currentNodeKey);
    const parentKey = parentKeyList[parentKeyList.length - 1];
    const defaultName = getDefaultNodeName(currentNodeKey, nodeTypes.enumeration, _.get(model, 'nodesOccMap'));
    const childOptions = getNodeTypeChildOptions(model.targetUserType,nodeTypes.enumeration);

    return (
      <div className={_.get(this.props.model.nodes[parentKey], 'children', []).length > 1 ? 'entry' : 'entry sole'}>
        <span className="wrapDesign">
          <Popup
            trigger={
              <Button style={this.props.clickedNode === this.props.currentNodeKey ? buttonStyleClicked : buttonStyle} onClick={() => this.props.handleNodePreview(ancestorList, currentNodeKey)}>
                {_.get(model.nodes[currentNodeKey], 'name', defaultName) || defaultName}
              </Button>
            }
            content={getNodePopupContent(model, 'name', currentNodeKey, defaultName)}
          />
          {renderAddButton &&
          <Dropdown icon="plus square" floating basic className="icon" style={addButtonSize}>
            <Dropdown.Menu>
              {childOptions.map(option =>
                renderDropdownItem(`Add ${option}`, () => this.props.handleAddNode(option, currentNodeKey, ancestorList))
              )}
            </Dropdown.Menu>
          </Dropdown>
          }
        </span>

        {_.get(model.nodes[currentNodeKey], 'children', []).length > 0 && (
          <div className={'noDropdownButton'}>
            {_.get(model.nodes[currentNodeKey], 'children', []).map(
              (childKey, index) => {
                if (model.nodes[childKey].type === nodeTypes.experiment) {
                  return (
                    <ExperimentWidget
                      key={`${index}${_.get(model.nodes[childKey], 'type')}`}
                      childIndex={index}
                      onModelChange={this.props.onModelChange}
                      model={model}
                      currentNodeKey={childKey}
                      canActivate={this.props.canActivate}
                      parentKeyList={ancestorList}
                      handleAddNode={this.props.handleAddNode}
                      handleNodePreview={this.props.handleNodePreview}
                      clickedNode={this.props.clickedNode}
                    />
                  );
                }
                if (model.nodes[childKey].type === nodeTypes.actions) {
                  return (
                    <ActionWidget
                      key={`${index}${_.get(model.nodes[childKey], 'type')}`}
                      onModelChange={this.props.onModelChange}
                      model={model}
                      currentNodeKey={childKey}
                      canActivate={this.props.canActivate}
                      parentKeyList={ancestorList}
                      handleNodePreview={this.props.handleNodePreview}
                      clickedNode={this.props.clickedNode}
                    />
                  );
                }
              },
            )}
          </div>
        )}
      </div>
    );
  }
}
